import React, { useState } from "react";
import { Player } from "video-react";
import { IP } from "../../../../internalServer";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
import ZoomableImage from "../../../../HwManagement/HomeWork/Pending/QuestionTypes/ZoomableImage";

export default function CheckBoxType({ response, questionNo, isAdaptiveCheck }) {
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. {response?.question_response?.question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
            {response?.question_response?.question?.is_mandatory && (
              <span style={{ marginLeft: "20px", color: "#AC1616", fontSize: "10px", fontWeight: "700" }}>
                *Mandatory
              </span>
            )}
          </div>
          {/* <div className="marksQue">
            {response?.question_response?.question?.correct_score} Marks
          </div> */}
        </div>
        {/* <div className='mt-3'>
                <img src='/HwImg/ImgQuetype.png' alt='img'></img>
            </div> */}

        {response?.question_response?.question?.attachments?.length > 0 &&
          response?.question_response?.question?.attachments?.map(
            (attachment, index) => (
              <div key={index}>
                {attachment.split(".").pop() !== "mp4" ? (
                  <>
                    {attachment.split(".").pop() === "jpg" ||
                      attachment.split(".").pop() === "jpeg" ||
                      attachment.split(".").pop() === "JPEG" ||
                      attachment.split(".").pop() === "JPG" ||
                      attachment.split(".").pop() === "PNG" ||
                      attachment.split(".").pop() === "png" ? (
                      <img
                        style={{ cursor: "pointer" }}
                        className="mt-3 imageWidthAndHeight"
                        src={IP + attachment?.replace(/^\./, "")}
                        alt="Attachment"
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                      />
                    ) : (
                      <div
                        key={index}
                        onClick={(e) =>
                          setPedingSubDetail({
                            ...pedingSubDetail,
                            pdfView: true,
                            attachment: attachment,
                          })
                        }
                        className="mt-2"
                      >
                        <div className="d-flex pdfContainer gap-2 p-2 "
                          onClick={() => {
                            if (!isError) {
                              handleClick(attachment);
                            }
                          }}>
                          <div className="d-flex align-items-center">
                            <img
                              className="extention_icon"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                          <div className="w-100">
                            <div className="pdfName">
                              {attachment?.replace(/^[^_]*_/, "")}
                            </div>
                            <div className="pdfFileSize">12 KB</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex pdfContainer gap-2 p-2 ">
                    <div className="d-flex align-items-center">
                      <img
                        className="extention_icon"
                        src={`${iconData?.find(
                          (i) =>
                            i.extension ===
                            attachment?.match(/\.([^.]+)$/)[1]
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                    <div className="w-100">
                      <div className="pdfName">
                        {attachment?.replace(/^[^_]*_/, "")}
                      </div>
                      <div className="pdfFileSize">12 KB</div>
                    </div>
                  </div>
                )}
              </div>
            )
          )}
        <div className="mt-3 optionContainer" style={{ width: isAdaptiveCheck ? "87%" : "60%" }}>
          {response?.question_response?.question?.options?.length > 0 &&
            response?.question_response?.question?.options?.map((option) => {
              return (
                <>
                  <div
                    key={option?.key}
                    className={`d-flex justify-content-between align-items-center mb-2 ${response?.question_response?.question?.correct_answers?.map(
                      (cAnswer) =>
                        cAnswer?.option_key === option?.key
                          ? "totalContainerCheckboxCorrectAnswer"
                          : cAnswer?.option_key !==
                            response?.question_response?.answer?.key &&
                            response?.question_response?.answer?.key === option?.key
                            ? "totalContainerCheckboxWrongAnswer"
                            : "totalContainerCheckboxNotAnswer"
                    )}`}
                  >
                    <div className="d-flex align-items-center gap-3 ">
                      <div className="d-flex gap-2">
                        {option?.key + ". "}
                        <input
                          type="checkbox"
                          readOnly
                          checked={
                            response?.question_response?.answer?.key ===
                            option?.key ||
                            response?.question_response?.question?.correct_answers?.some(
                              (cAnswer) => cAnswer?.option_key === option?.key
                            ) ||
                            false
                          }
                          className={`${response?.question_response?.question?.correct_answers?.some(
                            (cAnswer) => cAnswer?.option_key === option?.key
                          )
                            ? "CorrectAnswerCheckbox"
                            : "WrongAnswerCheckbox"
                            } d-flex align-items-center mt-1`}
                        />
                      </div>

                      <div className="QueOptionsChecked d-flex align-items-center">
                        {option?.value}
                      </div>
                    </div>
                    {response?.question_response?.answer?.key === option?.key && (
                      <div
                        className={`mb-2 ${response?.question_response?.question?.correct_answers?.map(
                          (cAnswer) =>
                            cAnswer?.option_key === option?.key
                              ? "CorrectAnswerText"
                              : "yourAnswerText"
                        )}`}
                      >
                        Your answer
                      </div>
                    )}
                    {response?.question_response?.question?.correct_answers
                      ?.length > 0 &&
                      response?.question_response?.question?.correct_answers?.map(
                        (cAnswer) =>
                          cAnswer?.option_key === option?.key && (
                            <div className="CorrectAnswerText">Correct Answer </div>
                          )
                      )}
                  </div>
                  <div className="ml-8">
                    {option.attachment &&
                      (() => {
                        const ext = option.attachment.split(".").pop().toLowerCase();
                        const isImage = ["jpg", "jpeg", "png"].includes(ext);
                        return isImage ? (
                          <ZoomableImage src={option.attachment} />
                        ) : null;
                      })()}
                  </div>
                </>
              )
            })}
        </div>

        {/* <div className="mt-4  optionContainer">
        <div className="d-flex  justify-content-between totalContainerCheckboxWrongAnswer align-items-center ">
          <div className="d-flex align-items-center gap-3 ">
            <div>
              <input
                type="checkbox"
                checked
                className="WrongAnswerCheckbox d-flex align-items-center"
              />
            </div>
            <div className="QueOptionsChecked d-flex align-items-center">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
          </div>
          <div className="yourAnswerText">Your answer</div>
        </div>
        
        <div className="d-flex justify-content-between totalContainerCheckboxNotAnswer align-items-center">
          <div className=" d-flex align-items-center gap-3 ">
            <div>
              <input type="checkbox" />
            </div>
            <div className="QueOptions d-flex align-items-center">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between totalContainerCheckboxCorrectAnswer align-items-center">
          <div className=" d-flex align-items-center gap-3 ">
            <div>
              <input
                checked
                type="checkbox"
                className="CorrectAnswerCheckbox  d-flex align-items-center"
              />
            </div>
            <div className="QueOptionsChecked">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
          </div>
          <div className="CorrectAnswerText">Correct answer </div>
        </div>

        <div className="d-flex justify-content-between totalContainerCheckboxNotAnswer align-items-center">
          <div className=" d-flex align-items-center gap-3 ">
            <div>
              <input type="checkbox" />
            </div>
            <div className="QueOptions d-flex align-items-center">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
          </div>
        </div> 
      </div>  */}

        {/* <div className="mt-4">
        <div className="d-flex align-items-center gap-2">
          <div className="d-flex align-items-center">
            <img src="/HwImg/WrongAnswerIcon.png " alt="" />
          </div>
          <div className="wrong">Wrong</div>
        </div>
      </div> */}
        {
          response?.question_response?.answer?.key === " " ? (
            <div className="d-flex align-items-center">
              <img src="/HwImg/WrongAnswerIcon.png" alt="" className="ml-2" />
              <div className="m-1 wrong">Student Not Answered</div>
            </div>
          ) : response?.question_response?.question?.correct_answers?.some(
            (cAnswer) => cAnswer?.option_key === response?.question_response?.answer?.key
          ) ? (
            // If at least one correct answer matches the student's answer, mark as Correct
            <div className="mt-3">
              <div className="d-flex align-items-center gap-2">
                <div className="d-flex align-items-center">
                  <img src="/HwImg/CoorectAnswerIcon.png" alt="" />
                </div>
                <div className="Corect" style={{ color: "#45BF55" }}>Correct</div>
              </div>
            </div>
          ) : (
            // If none of the correct answers match, mark as Wrong
            <div className="mt-3">
              <div className="d-flex align-items-center gap-2">
                <div className="d-flex align-items-center">
                  <img src="/HwImg/WrongAnswerIcon.png" alt="" />
                </div>
                <div className="wrong">Wrong</div>
              </div>
            </div>
          )
        }
        {
          isAdaptiveCheck ? null : (
            <div className="mt-2 pt-2">
              <div className="TeacherRemarkHeader">TEACHER'S REMARK</div>
              {response?.comment ? (
                <div className="TeacerRemarkText mt-2">{response?.comment}</div>
              ) : (
                <div className=" TeacerRemarkText mt-2">No Remarks</div>
              )}
            </div>
          )
        }

      </div >
      {
        pedingSubDetail.pdfView && (
          <PdfViewer
            handleRemovePdfVivwer={handleRemovePdfVivwer}
            attachment={pedingSubDetail?.attachment}
          />
        )
      }
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError || responseAttach.split(".").pop() === "pptx" || responseAttach.split(".").pop() === "PPTX" || responseAttach.split(".").pop() === "PPT" || responseAttach.split(".").pop() === "PPT" ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
